.slider {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  min-height: 132px;

  &.isLoading {
    justify-content: center;
    align-items: center;
  }
}

.item {
  flex: 0 0 30%;
  margin-right: var(--space-s);
}

.isSmall .item {
  flex-basis: 20%;
}
